import {
    ACCOUNTS_CREATE_EDIT_ACCOUNT_OPEN_MODAL,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_CLOSE_MODAL,
    ACCOUNTS_CREATE_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_ACCOUNT_RESULT,
    ACCOUNTS_EDIT_ACCOUNT_REQUEST,
    ACCOUNTS_EDIT_ACCOUNT_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_RESULT,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_RESULT,
    ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST,
    ACCOUNTS_CREDENCIAL_VALIDATION_RESULT
} from 'Redux/actionTypes';

export const accountsCredencialValidationRequest = (data) => ({
    type: ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST,
    payload: data
})

export const accountsCredencialValidationResult = (data) => ({
    type: ACCOUNTS_CREDENCIAL_VALIDATION_RESULT,
    payload: data
})
export const accountsGetRoleModuleTemplateRequest = (id) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    payload: id
})

export const accountsGetRoleModuleTemplateResult = (result) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_RESULT,
    payload: result
})

export const accountsGetCustomRoleRequest = (id) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST,
    payload: id
})

export const accountsGetCustomRoleResult = (result) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_RESULT,
    payload: result
})

export const accountsCreateEditAccountOpenModal = (data) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_OPEN_MODAL,
    payload: data
})

export const accountsCreateEditAccountCloseModal = () => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_CLOSE_MODAL
})

export const accountsSearchRolesRequest = (data) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST,
    payload: data
})

export const accountsSearchRolesResult = (result) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_RESULT,
    payload: result
})

export const accountsCreateAccountRequest = (data) => ({
    type: ACCOUNTS_CREATE_ACCOUNT_REQUEST,
    payload: data
})

export const accountsCreateAccountResult = (result) => ({
    type: ACCOUNTS_CREATE_ACCOUNT_RESULT,
    payload: result
})

export const accountsEditAccountRequest = (data) => ({
    type: ACCOUNTS_EDIT_ACCOUNT_REQUEST,
    payload: data
})

export const accountsEditAccountResult = (result) => ({
    type: ACCOUNTS_EDIT_ACCOUNT_RESULT,
    payload: result
})

export const accountsGetRoleRequest = (id) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST,
    payload: id
})

export const accountsGetRoleResult = (result) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_RESULT,
    payload: result
})

export const accountsGetAccountRequest = (id) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST,
    payload: id
})

export const accountsGetAccountResult = (result) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_RESULT,
    payload: result
})

export const accountsSearchTimeZonesRequest = () => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST
})

export const accountsSearchTimeZonesResult = (result) => ({
    type: ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_RESULT,
    payload: result
})